import type { SessionService } from '@efdigital/ll-addon-auth';
import { getOwner } from '@ember/owner';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';

import { initializeAuthHandler } from '../data/handlers/auth-handler.ts';
import type CoachService from '../services/coach.ts';

export default class ApplicationRoute extends Route {
  @service declare session: SessionService;
  @service declare coach: CoachService;
  @service declare router: RouterService;

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);

    // Auth: initialize the auth handler
    initializeAuthHandler(getOwner(this)!);
    await this.session.getCurrent();

    // Cronofy: try to validate the code from the query string
    if (await this.coach.validateCodeFromQueryParams()) {
      // If the code is valid, transition to the availability settings page
      // because this is where the coach would have been before
      // they were redirected to Cronofy's authorization page.
      this.router.transitionTo('coaching.coach.settings.availability');
    }
  }
}
